<template>
  <div id="page-lists">
    <v-container grid-list-lg fluid>
      <v-layout row wrap>
        <v-flex xl9 lg12 md12 sm12 xs12>
       <historyTable />
     </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import historyTable from '@/components/widgets/list/HistoryTable'
export default {
  name:"historia",
  components: {
    historyTable
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
